import React, { ElementType } from 'react';
import parse from 'html-react-parser';
import IconsHolder from '../icons-holder/IconsHolder';
import { IIconCard } from '../../interfaces/generic';
import { IconsHolderVariant } from '../icons-holder/IconsHolder';
import { removeExtraSpaces } from '../../scripts/helpers';
type IconCardFloatingVariants = 'white' | 'primary';
type IconCardFloatingGroupProps = {
  className?: string;
  class?: string;
  content: IIconCard[];
  headingTag?: ElementType<any>;
  variant?: IconCardFloatingVariants;
};

class IconCardFloatingGroup extends React.Component<IconCardFloatingGroupProps> {
  constructor(props: IconCardFloatingGroupProps) {
    super(props);
  }
  render() {
    const content = this.props.content;
    const classN = this.props.class || this.props.className || '';
    const CustomHeadingTag = this.props.headingTag || 'h3'; //start with capital
    const returnColSize = () => {
      const remainder = content.length % 3;
      return remainder === 0 ? 'col-lg-4' : 'col-lg-6';
    };
    const variantText = () => {
      return this.props.variant === 'primary' ? '' : 'text-white';
    };
    const variantIcon = () => {
      //'light'| 'primary' |'danger'|'success'
      let variant: IconsHolderVariant = 'light';
      if (this.props.hasOwnProperty('variant')) {
        variant = this.props.variant === 'primary' ? 'primary' : variant;
      }
      return variant;
    };
    return (
      <div className={`${classN} row gx-lg-6 gy-4`}>
        {content.map((element: IIconCard, i: number) => (
          <div
            key={i}
            className={removeExtraSpaces(`${returnColSize()}`)}>
            <div className={`d-flex align-items-start`}>
              <IconsHolder
                icon={element.icon}
                variant={variantIcon()}
                size="lg"
              />
              <div className="ms-3">
                <CustomHeadingTag className={`h5 ${variantText()}`}>
                  {parse(element.heading)}
                </CustomHeadingTag>
                {element.subcopy && (
                  <p className={`mb-0 ${variantText() || 'text-gray'}`}>{parse(element.subcopy)}</p>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default IconCardFloatingGroup;
